import { v4 as uuidv4 } from 'uuid';
import { MarketingCompensatedDiscountsPluginView } from './MarketingCompensatedDiscountsPluginView';
import i18n from '../../../i18n';
import { MarketingCompensatedDiscountsGridPluginSettings } from './MarketingCompensatedDiscountsGridPluginSettings';

export const MarketingCompensatedDiscountsTab = (): ITab => {
    const t = (value: string) => i18n.t("sidePanel.directory.submenu." + value);
    return {
        id: uuidv4(),
        title: t("marketingCompensatedDiscounts"),
        view: {
            content: MarketingCompensatedDiscountsGridPluginSettings
                ? <MarketingCompensatedDiscountsPluginView gridId={uuidv4()} plugin={MarketingCompensatedDiscountsGridPluginSettings} />
                : <p> Справочник не настроен</p>
        }
    }
}
